module.exports = __webpack_public_path__ + "static/media/Spring_Campus_Outdoor_Classrooms_20180503167_JO.4a7f3980.jpg";